module.exports = __webpack_public_path__ + "images/help/cloud-small-7674581aaf36e9cc101ef8c833523563.png";